import React, { CSSProperties } from 'react';

interface LockClosedProps {
  fill?: string;
  secondaryfill?: string;
  width?: string;
  height?: string;
  style?: CSSProperties;
  className?: string;
}

const LockClosed: React.FC<LockClosedProps> = ({ fill = 'currentColor', secondaryfill, width = '100%', height = '100%', style, className }) => {
  return (
    <svg className={className} height={height} width={width} viewBox="0 0 1060 1060" xmlns="http://www.w3.org/2000/svg" style={style}>
      <g fill={fill}>
        <defs />
        <rect className="cls-1" height="438" width="454" fill="none" rx="73" ry="73" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px" x="303" y="435.75" />
        <path className="cls-1" d="M405 435.75v-124.5c0-124.5 125-125 125-125s125-.5 125 125v124.5H405z" fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="50px" />
      </g>
    </svg>
  );
};

export default LockClosed;
